export enum DeactivateViews {
  hidden = 'hidden',
  confirming = 'confirming',
  confirmingWithApps = 'confirmingWithApps',
}
